// Necklace Builder - Utility Functions
// This file contains utility functions for the necklace builder

// Make functions available on window object for Alpine.js component
window.getVariantImage = getVariantImage;
window.getSelectedCharmValue = getSelectedCharmValue;
window.updateImage = updateImage;
window.selectCharmOption = selectCharmOption;
window.updateSelectedVariant = updateSelectedVariant;
window.buildMainOptions = buildMainOptions;
window.selectOption = selectOption;
window.scrollToOption = scrollToOption;
window.scrollToCharmOption = scrollToCharmOption;
window.addToCart = addToCart;
window.addItemToCart = addItemToCart;
window.resetBuilder = resetBuilder;
window.getTotalPrice = getTotalPrice;
window.getLengthOptions = getLengthOptions;
window.getCanAddToCart = getCanAddToCart;
window.getImageAlt = getImageAlt;
window.getSelectedCharmsCount = getSelectedCharmsCount;
window.hasAnyCharmsSelected = hasAnyCharmsSelected;
window.getSelectedCharmImage = getSelectedCharmImage;
window.getCombinationImage = getCombinationImage;
window.shouldUseOverlayMode = shouldUseOverlayMode;
window.getSelectedCharmTitle = getSelectedCharmTitle;
window.getScrollbarWidth = getScrollbarWidth;
window.getScrollbarPosition = getScrollbarPosition;
window.getScrollbarImagePosition = getScrollbarImagePosition;
window.scrollToPosition = scrollToPosition;
window.startDrag = startDrag;
window.initCustomScrollbars = initCustomScrollbars;
window.isMobileDevice = isMobileDevice;
window.scrollToTopOnMobile = scrollToTopOnMobile;

// Utility function to get variant image
function getVariantImage(variant, product, forThumbnail = false, defaultImage = '') {
  if (!variant) return defaultImage;
  
  // For thumbnails, use original variant images directly
  if (forThumbnail) {
    // First try to find image by image_id in product.images (like looking up price by variant.id)
    if (variant.image_id && product.images) {
      const variantImage = product.images.find(img => img.id === variant.image_id);
      if (variantImage && variantImage.src) {
        return variantImage.src;
      }
    }
    
    // Special case for vessel drop - construct original image URL from variant data
    if (product.handle === 'vessel-drop' && variant.option2) {
      // Special case for letter M - use the new resized image
      if (variant.option2.toUpperCase() === 'M') {
        return 'https://cdn.shopify.com/s/files/1/0561/1464/3101/files/m_resized.webp?v=1755015313';
      }
      return `https://cdn.shopify.com/s/files/1/0561/1464/3101/files/UO_charm_front-${variant.option2.toLowerCase()}-web.jpg?v=1748976281`;
    }
    
    // If variant has direct image property, use that
    if (variant.image?.src) {
      return variant.image.src;
    }
    
    // If variant has featured_media, use that
    if (variant.featured_media?.preview_image?.src) {
      return variant.featured_media.preview_image.src;
    }
    
    // Fallback to product image
    if (product.image?.src) {
      return product.image.src;
    }
    
    return defaultImage;
  }
  
  // Check for custom image mappings first (these take priority for overlays)
  // For vessel drop images, use the new image mapping
  if (product.handle === 'vessel-drop' && variant.option2) {
    if (!window._vesselDropImageMap) {
      window._vesselDropImageMap = {
        'A': 'a.png?v=1753721189', 'B': 'b.png?v=1753721189', 'C': 'c.png?v=1753721189',
        'D': 'd.png?v=1753721189', 'E': 'e.png?v=1753721189', 'F': 'f.png?v=1753721189',
        'G': 'g.png?v=1753721189', 'H': 'h.png?v=1753721189', 'I': 'i.png?v=1753721189',
        'J': 'j.png?v=1753721189', 'K': 'resized_k.png?v=1753721189', 'L': 'resized_l.png?v=1753721189',
        'M': 'm_resized.png?v=1754682336', 'N': 'n.png?v=1753721210', 'O': 'o.png?v=1753721210',
        'P': 'resized_p.png?v=1753721189', 'Q': 'resized_q.png?v=1753721189', 'R': 'r.png?v=1753721210',
        'S': 'resized_s.png?v=1753721189', 'T': 'resized_t.png?v=1753721189', 'U': 'resized_u.png?v=1753721189',
        'V': 'resized_v.png?v=1753721189', 'W': 'resized_w.png?v=1753721189', 'X': 'resized_x.png?v=1753721189',
        'Y': 'resized_y.png?v=1753721189', 'Z': 'resized_z.png?v=1753721189', '0': '0.png?v=1753721189',
        '1': '1.png?v=1753721189', '2': '2.png?v=1753721189', '3': '3.png?v=1753721189',
        '4': '4.png?v=1753721189', '5': '5.png?v=1753721189', '6': '6.png?v=1753721189',
        '7': '7.png?v=1753721189', '8': '8.png?v=1753721189', '9': '9.png?v=1753721189'
      };
    }
        
    const filename = window._vesselDropImageMap[variant.option2];
    if (filename) {
      return filename.startsWith('https://') ? filename : `https://cdn.shopify.com/s/files/1/0561/1464/3101/files/${filename}`;
    }
  }
  
  // For carriage drop stone images, use the new Frame images
  if (product.handle === 'carriage-drop-asscher-colored-stone' && variant.option2) {
    if (!window._carriageDropImageMap) {
      window._carriageDropImageMap = {
        'EMERALD': 'Frame_37.png?v=1753721189',
        'PINK SAPPHIRE': 'Frame_38.png?v=1753721189', 
        'BLUE SAPPHIRE': 'Frame_36.png?v=1753721189'
      };
    }
    
    const filename = window._carriageDropImageMap[variant.option2];
    if (filename) {
      return `https://cdn.shopify.com/s/files/1/0561/1464/3101/files/${filename}`;
    }
  }
  
  // Try to get variant-specific image using image_id (fallback)
  if (variant.image_id && product.images) {
    const variantImage = product.images.find(img => img.id === variant.image_id);
    if (variantImage && variantImage.src) {
      return variantImage.src;
    }
  }
  
  // Try variant featured media (for newer Shopify structures)
  if (variant.featured_media?.preview_image?.src) {
    return variant.featured_media.preview_image.src;
  }
  
  // Try variant image property (legacy structure)
  if (variant.image?.src) {
    return variant.image.src;
  }
  
  // Fall back to product-level images only if no variant image exists
  if (product.featured_media?.preview_image?.src) {
    return product.featured_media.preview_image.src;
  }
  
  if (product.image?.src) {
    return product.image.src;
  }
  
  return defaultImage;
}

// Utility function to get selected charm value
function getSelectedCharmValue(charmType, selectedOptions, vesselDrop, carriageDrop, carriagePlate, tuskDrop, megaTuskDrop) {
  const selectedVariantId = selectedOptions[charmType];
  if (!selectedVariantId) return null;

  let product = null;
  switch (charmType) {
    case 'vesselDrop':
      product = vesselDrop;
      break;
    case 'carriageDrop':
      // For carriageDrop, we need to search across all stone products
      // So we'll handle this separately below
      break;
    case 'carriagePlate':
      product = carriagePlate;
      break;
  }
  
  // Handle array for stones (carriageDrop) - search across all stone products
  if (charmType === 'carriageDrop' && Array.isArray(selectedVariantId)) {
    if (selectedVariantId.length === 0) return null;
    if (selectedVariantId.length === 1) {
      // Single stone selection
      const variant = findStoneVariant(selectedVariantId[0], carriageDrop, tuskDrop, megaTuskDrop);
      return variant ? (variant.option2 || variant.option1) : null;
    } else {
      // Multiple stone selection - return array of stone names
      const stones = selectedVariantId.map(id => {
        const variant = findStoneVariant(id, carriageDrop, tuskDrop, megaTuskDrop);
        return variant ? (variant.option2 || variant.option1) : null;
      }).filter(Boolean);
      return stones.length > 0 ? stones : null;
    }
  }
  
  // Handle single stone selection (backward compatibility)
  if (charmType === 'carriageDrop') {
    const variant = findStoneVariant(selectedVariantId, carriageDrop, tuskDrop, megaTuskDrop);
    return variant ? (variant.option2 || variant.option1) : null;
  }

  if (!product?.variants) return null;
  
  // Handle single selection for other charms
  const variant = product.variants.find(v => v.id === selectedVariantId);
  return variant ? (variant.option2 || variant.option1) : null;
}

// Utility function to update image
function updateImage(selectedOptions, vesselDrop, carriageDrop, carriagePlate, buildCombinationKey) {
  // This function is called to trigger image updates
  // The actual image update logic is handled by Alpine.js reactive properties
}

// Utility function to select charm option
function selectCharmOption(charmType, variant, selectedOptions, lastSelectedCharm, updateImage) {
  // Helper function to count total selected charms
  function getTotalCharmCount() {
    let count = 0;
    if (selectedOptions.carriagePlate) count++;
    if (selectedOptions.vesselDrop) count++;
    if (selectedOptions.carriageDrop) {
      if (Array.isArray(selectedOptions.carriageDrop)) {
        count += selectedOptions.carriageDrop.length;
      } else {
        count++;
      }
    }
    return count;
  }

  // Helper function to remove a carriage plate or vessel letter to make room
  function makeRoomForNewSelection() {
    // Remove carriage plate first, then vessel letter
    if (selectedOptions.carriagePlate) {
      delete selectedOptions.carriagePlate;
    } else if (selectedOptions.vesselDrop) {
      delete selectedOptions.vesselDrop;
    }
  }

  // Special handling for stones (carriageDrop) - allow up to 2 selections
  if (charmType === 'carriageDrop') {
    if (!selectedOptions[charmType]) {
      selectedOptions[charmType] = [];
    }
    
    const currentSelections = selectedOptions[charmType];
    const variantIndex = currentSelections.indexOf(variant.id);
    
    if (variantIndex > -1) {
      // Deselect if already selected
      currentSelections.splice(variantIndex, 1);
      if (currentSelections.length === 0) {
        delete selectedOptions[charmType];
      }
    } else {
      // If we already have 2 stones, replace the first one (don't remove letter/carriage)
      if (currentSelections.length >= 2) {
        currentSelections[0] = variant.id;
        lastSelectedCharm.value = charmType;
      } else {
        // Check if adding this stone would exceed the 3 charm limit
        const currentCount = getTotalCharmCount();
        
        if (currentCount >= 3) {
          // Would exceed limit - remove carriage plate or vessel letter to make room
          makeRoomForNewSelection();
        }
        
        // Add new stone
        currentSelections.push(variant.id);
        lastSelectedCharm.value = charmType;
      }
    }
  } else {
    // For other charm options (letter and plate)
    // If the same charm variant is already selected, deselect it
    if (selectedOptions[charmType] === variant.id) {
      delete selectedOptions[charmType];
      // Reset lastSelectedCharm if we're deselecting the last selected charm
      if (lastSelectedCharm.value === charmType) {
        lastSelectedCharm.value = null;
      }
    } else {
      // Check if adding this charm would exceed the 3 charm limit
      const currentCount = getTotalCharmCount();
      if (currentCount >= 3) {
        // Would exceed limit - remove carriage plate or vessel letter to make room
        makeRoomForNewSelection();
      }
      
      // If something else is selected in this row (charmType), replace it
      // If nothing is selected in this row, select it
      selectedOptions[charmType] = variant.id;
      lastSelectedCharm.value = charmType; // Track the most recent selection
    }
  }
  
  // Scroll to top on mobile when a carriage/card is clicked
  scrollToTopOnMobile();
  
  updateImage();
}

// Utility function to update selected variant
function updateSelectedVariant(mainProduct, selectedOptions, mainOptions, basePrice, currentVariant) {
  if (!mainProduct?.variants) return;
  
  // Find the variant that matches current selections
  const variant = mainProduct.variants.find(v => {
    // Check all available option positions
    return mainOptions.every(optionGroup => {
      const selectedValue = selectedOptions[optionGroup.position];
      
      // For single-value options, always use the single value
      if (!optionGroup.isMultiple) {
        return v[optionGroup.position] === optionGroup.values[0].value;
      }
      
      // For multi-value options, require a selection that matches
      return selectedValue && v[optionGroup.position] === selectedValue;
    });
  });
  
  if (variant) {
    basePrice.value = Number(variant.price);
    currentVariant.value = variant;
  } else if (mainProduct.variants.length > 0) {
    // Fallback to first variant if no perfect match
    const fallbackVariant = mainProduct.variants[0];
    basePrice.value = Number(fallbackVariant.price);
    currentVariant.value = fallbackVariant;
  }
}

// Utility function to build main options
function buildMainOptions(mainProduct, mainOptions, getVariantImage) {
  mainOptions.value = [];
  
  // Get product options info from product.options if available
  const productOptions = mainProduct.options || [];
  
  // Check each option position (option1, option2, option3, etc.)
  for (let i = 1; i <= 3; i++) {
    const optionKey = `option${i}`;
    const uniqueValues = new Set();
    
    // Extract unique values for this option position
    mainProduct.variants.forEach(variant => {
      if (variant[optionKey]) {
        uniqueValues.add(variant[optionKey]);
      }
    });
    
    // Create an option group if there are any values
    if (uniqueValues.size > 0) {
      let optionName = `Option ${i}`;
      
      // If product.options exists and has the right structure, use it
      if (productOptions.length >= i && productOptions[i - 1]) {
        optionName = productOptions[i - 1].name || optionName;
      }
      
      const optionValues = Array.from(uniqueValues).map(value => {
        const variantWithValue = mainProduct.variants.find(v => v[optionKey] === value);
        return {
          value: value,
          image: getVariantImage(variantWithValue, mainProduct),
          price: variantWithValue ? Number(variantWithValue.price) : 0
        };
      });
      
      mainOptions.value.push({
        position: optionKey,
        name: optionName.toUpperCase(),
        values: optionValues,
        isMultiple: uniqueValues.size > 1
      });
    }
  }
}

// Utility function to select main product option
function selectOption(category, optionValue, selectedOptions, updateSelectedVariant, updateImage) {
  // For main product options, each option group is its own "row"
  // If the same option is already selected, deselect it
  if (selectedOptions[category] === optionValue) {
    delete selectedOptions[category];
  } else {
    // If something else is selected in this row (category), replace it
    // If nothing is selected in this row, select it
    selectedOptions[category] = optionValue;
  }
  
  // Scroll to top on mobile when a main product option is clicked
  scrollToTopOnMobile();
  
  // Find and update with the selected variant
  updateSelectedVariant();
  updateImage();
}

// Utility function to scroll to selected option
function scrollToOption(category, optionValue, selectOption, $nextTick) {
  // Select the option first
  selectOption(category, optionValue);
  
  // Then scroll to it
  $nextTick(() => {
    const carousel = document.querySelector(`[data-category="${category}"]`);
    const optionCard = carousel?.querySelector(`[data-option-value="${optionValue}"]`);
    
    if (carousel && optionCard) {
      const scrollLeft = optionCard.offsetLeft - carousel.offsetLeft - 16; // 16px for padding
      carousel.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
  });
}

// Utility function to scroll to selected charm option
function scrollToCharmOption(charmType, variant, selectCharmOption, $nextTick) {
  // Select the charm first (this will trigger updateImage)
  selectCharmOption(charmType, variant);
  
  // Then scroll to it
  $nextTick(() => {
    const carousel = document.querySelector(`[data-category="${charmType}"]`);
    const optionCard = carousel?.querySelector(`[data-variant-id="${variant.id}"]`);
    
    if (carousel && optionCard) {
      const scrollLeft = optionCard.offsetLeft - carousel.offsetLeft - 16; // 16px for padding
      carousel.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
  });
}

// Utility function to add complete necklace to cart
async function addToCart(canAddToCart, currentVariant, mainProduct, selectedOptions, carriagePlate, vesselDrop, carriageDrop, getSelectedCharmsCount, addItemToCart, tuskDrop, megaTuskDrop) {
  if (!canAddToCart) {
    return;
  }

  try {
    let lastResponse;

    // Always add base necklace - use selected variant or default to first variant
    const baseVariant = currentVariant || (mainProduct?.variants?.[0]);
    if (baseVariant) {
      lastResponse = await addItemToCart(baseVariant.id, 1, {
        'Product Type': 'Base Necklace',
        'Total Items': `1 + ${getSelectedCharmsCount()} carriages`
      });
    }

    // Add selected carriages
    if (selectedOptions.carriagePlate && carriagePlate) {
      const variant = carriagePlate.variants.find(v => v.id === selectedOptions.carriagePlate);
      if (variant) {
        lastResponse = await addItemToCart(variant.id, 1, {
          'Product Type': 'Carriage',
          'Carriage Name': 'Carriage Plate',
          'Base Necklace': mainProduct?.title || 'System Necklace'
        });
      }
    }

    if (selectedOptions.vesselDrop && vesselDrop) {
      const variant = vesselDrop.variants.find(v => v.id === selectedOptions.vesselDrop);
      if (variant) {
        lastResponse = await addItemToCart(variant.id, 1, {
          'Product Type': 'Carriage',
          'Carriage Name': 'Vessel Drop',
          'Customization': variant.option2 || variant.option1 || '',
          'Base Necklace': mainProduct?.title || 'System Necklace'
        });
      }
    }

    if (selectedOptions.carriageDrop) {
      // Helper function to get product name for stone variant
      const getProductName = (variantId) => {
        if (carriageDrop?.variants?.find(v => v.id === variantId)) return 'Carriage Drop';
        if (tuskDrop?.variants?.find(v => v.id === variantId)) return 'Tusk Drop';
        if (megaTuskDrop?.variants?.find(v => v.id === variantId)) return 'Mega Tusk Drop';
        return 'Stone';
      };
      
      if (Array.isArray(selectedOptions.carriageDrop)) {
        // Handle multiple stone selections
        for (const variantId of selectedOptions.carriageDrop) {
          const variant = findStoneVariant(variantId, carriageDrop, tuskDrop, megaTuskDrop);
          if (variant) {
            lastResponse = await addItemToCart(variant.id, 1, {
              'Product Type': 'Carriage',
              'Carriage Name': getProductName(variantId),
              'Stone': variant.option2 || variant.option1 || '',
              'Base Necklace': mainProduct?.title || 'System Necklace'
            });
          }
        }
      } else {
        // Handle single stone selection (backward compatibility)
        const variant = findStoneVariant(selectedOptions.carriageDrop, carriageDrop, tuskDrop, megaTuskDrop);
        if (variant) {
          lastResponse = await addItemToCart(variant.id, 1, {
            'Product Type': 'Carriage',
            'Carriage Name': getProductName(selectedOptions.carriageDrop),
            'Stone': variant.option2 || variant.option1 || '',
            'Base Necklace': mainProduct?.title || 'System Necklace'
          });
        }
      }
    }

    
    // Trigger the theme's cart update event with the last response data
    document.body.dispatchEvent(
      new CustomEvent('baseline:cart:afteradditem', {
        bubbles: true,
        detail: {
          response: lastResponse,
          sourceId: 'necklace-builder-form'
        }
      })
    );

  } catch (error) {
    console.error('Error adding to cart:', error);
  }
}

// Utility function to add individual item to cart
async function addItemToCart(variantId, quantity, properties) {
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', quantity);
  
  formData.append('sections', 'cart-items,cart-footer,cart-item-count,cart-live-region');
  formData.append('sections_url', window.location.pathname);
  
  Object.entries(properties).forEach(([key, value]) => {
    formData.append(`properties[${key}]`, value);
  });

  const options = fetchConfigDefaults('application/javascript');
  options.body = formData;
  options.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete options.headers['Content-Type'];

  const response = await fetch(theme.routes.cart_add_url, options);
  const data = await response.json();

  if (data.status) {
    throw new Error(data.description || data.message || 'Failed to add to cart');
  }

  return data;
}

// Utility function to reset the necklace builder
function resetBuilder(selectedOptions, lastSelectedCharm, lengthOptions, updateSelectedVariant, updateImage) {
  // Reset all selections by clearing the object
  Object.keys(selectedOptions).forEach(key => delete selectedOptions[key]);
  lastSelectedCharm = null;
  
  // Reset to default length (16 inches) if available
  const defaultLength = "16 INCHES";
  if (lengthOptions.find(l => l.value === defaultLength)) {
    selectedOptions.option2 = defaultLength;
  }
  
  // Update the selected variant to match the reset state
  updateSelectedVariant();
  
  // Update the image display
  updateImage();
}

// Utility function to find stone variant across all stone products
function findStoneVariant(variantId, carriageDrop, tuskDrop, megaTuskDrop) {
  if (carriageDrop?.variants) {
    const variant = carriageDrop.variants.find(v => v.id === variantId);
    if (variant) return variant;
  }
  if (tuskDrop?.variants) {
    const variant = tuskDrop.variants.find(v => v.id === variantId);
    if (variant) return variant;
  }
  if (megaTuskDrop?.variants) {
    const variant = megaTuskDrop.variants.find(v => v.id === variantId);
    if (variant) return variant;
  }
  return null;
}

function isVariantInProduct(variantId, product) {
  if (!variantId || !product?.variants) return false;
  return product.variants.some(variant => variant.id === variantId);
}

function selectionIncludesNonCarriageStone(selectedOptions, carriageDrop, tuskDrop, megaTuskDrop) {
  if (!selectedOptions.carriageDrop) return false;
  const selectedIds = Array.isArray(selectedOptions.carriageDrop) ?
    selectedOptions.carriageDrop :
    [selectedOptions.carriageDrop];
  
  return selectedIds.some(id => {
    if (isVariantInProduct(id, carriageDrop)) {
      return false;
    }
    return isVariantInProduct(id, tuskDrop) || isVariantInProduct(id, megaTuskDrop);
  });
}

// Utility function to get total price
function getTotalPrice(selectedOptions, currentVariant, mainProduct, carriagePlate, vesselDrop, carriageDrop, basePrice, tuskDrop, megaTuskDrop) {
  // Always include base necklace price - use selected variant or default to first variant
  const baseVariant = currentVariant || (mainProduct?.variants?.[0]);
  let total = baseVariant ? Number(baseVariant.price) : (basePrice || 0);
  
  // Add carriage prices
  if (selectedOptions.carriagePlate && carriagePlate) {
    const variant = carriagePlate.variants.find(v => v.id === selectedOptions.carriagePlate);
    if (variant) total += Number(variant.price);
  }
  
  if (selectedOptions.vesselDrop && vesselDrop) {
    const variant = vesselDrop.variants.find(v => v.id === selectedOptions.vesselDrop);
    if (variant) total += Number(variant.price);
  }
  
  if (selectedOptions.carriageDrop) {
    if (Array.isArray(selectedOptions.carriageDrop)) {
      // Handle multiple stone selections
      selectedOptions.carriageDrop.forEach(variantId => {
        const variant = findStoneVariant(variantId, carriageDrop, tuskDrop, megaTuskDrop);
        if (variant) total += Number(variant.price);
      });
    } else {
      // Handle single stone selection (backward compatibility)
      const variant = findStoneVariant(selectedOptions.carriageDrop, carriageDrop, tuskDrop, megaTuskDrop);
      if (variant) total += Number(variant.price);
    }
  }

  return total;
}

// Utility function to get length options
function getLengthOptions(mainProduct) {
  // Extract unique length values from the main product variants
  const lengthValues = [];
  if (mainProduct?.variants) {
    mainProduct.variants.forEach(variant => {
      if (variant.option2 && !lengthValues.find(l => l.value === variant.option2)) {
        lengthValues.push({
          value: variant.option2,
          price: Number(variant.price)
        });
      }
    });
  }
  return lengthValues;
}

// Utility function to check if can add to cart
function getCanAddToCart() {
  // Always allow adding to cart since we'll include base necklace by default
  return true;
}

// Utility function to get image alt text
function getImageAlt(selectedOptions, mainProduct, mainOptions, getSelectedCharmTitle) {
  const parts = [mainProduct?.title || 'Custom Necklace'];
  
  // Add all selected main product options to the alt text
  mainOptions.forEach(optionGroup => {
    const selectedValue = selectedOptions[optionGroup.position];
    if (selectedValue) {
      parts.push(`${selectedValue} ${optionGroup.name}`);
    }
  });
  
  // Add selected carriages with their customizations
  if (selectedOptions.carriagePlate) {
    parts.push('Carriage Plate');
  }
  if (selectedOptions.vesselDrop) {
    const title = getSelectedCharmTitle('vesselDrop');
    parts.push(title ? `Vessel Drop ${title}` : 'Vessel Drop');
  }
  if (selectedOptions.carriageDrop) {
    const title = getSelectedCharmTitle('carriageDrop');
    parts.push(title ? `Carriage Drop ${title}` : 'Carriage Drop');
  }
  
  return parts.join(' - ');
}

// Utility function to get selected charms count
function getSelectedCharmsCount(selectedOptions) {
  let count = 0;
  if (selectedOptions.carriagePlate) count++;
  if (selectedOptions.vesselDrop) count++;
  if (selectedOptions.carriageDrop) {
    if (Array.isArray(selectedOptions.carriageDrop)) {
      count += selectedOptions.carriageDrop.length;
    } else {
      count++;
    }
  }
  return count;
}

// Utility function to check if any charms are selected
function hasAnyCharmsSelected(selectedOptions) {
  const hasStones = selectedOptions.carriageDrop && 
    (Array.isArray(selectedOptions.carriageDrop) ? 
      selectedOptions.carriageDrop.length > 0 : 
      true);
  return !!(selectedOptions.carriageDrop || selectedOptions.vesselDrop || hasStones);
}

// Utility function to get selected charm image
function getSelectedCharmImage(charmType, selectedOptions, carriagePlate, vesselDrop, carriageDrop, getCombinationImageUrl, getVariantImage, tuskDrop, megaTuskDrop) {
  const selectedVariantId = selectedOptions[charmType];
  if (!selectedVariantId) return null;

  let product, variant;
  switch (charmType) {
    case 'carriagePlate':
      product = carriagePlate;
      break;
    case 'vesselDrop':
      product = vesselDrop;
      break;
    case 'carriageDrop':
      // For carriageDrop, we'll search across all stone products
      break;
    default:
      return null;
  }

  // Handle array for stones (carriageDrop) - search across all stone products
  if (charmType === 'carriageDrop' && Array.isArray(selectedVariantId)) {
    if (selectedVariantId.length === 0) return null;
    if (selectedVariantId.length === 2) {
      // Two stones - use combination image
      const stones = selectedVariantId.map(id => {
        const v = findStoneVariant(id, carriageDrop, tuskDrop, megaTuskDrop);
        return v ? (v.option2 || v.option1) : null;
      }).filter(Boolean);
      
      if (stones.length === 2) {
        const combinationKey = stones.sort().map(s => s.toLowerCase().replace(' ', '_')).join('_');
        const combinationImage = getCombinationImageUrl(combinationKey);
        if (combinationImage) {
          return combinationImage;
        }
      }
    }
    // Fall back to first stone for single stone or if combination not found
    variant = findStoneVariant(selectedVariantId[0], carriageDrop, tuskDrop, megaTuskDrop);
    if (variant) {
      // Find which product this variant belongs to
      if (carriageDrop?.variants?.find(v => v.id === variant.id)) product = carriageDrop;
      else if (tuskDrop?.variants?.find(v => v.id === variant.id)) product = tuskDrop;
      else if (megaTuskDrop?.variants?.find(v => v.id === variant.id)) product = megaTuskDrop;
    }
  } else if (charmType === 'carriageDrop') {
    // Handle single stone selection (backward compatibility)
    variant = findStoneVariant(selectedVariantId, carriageDrop, tuskDrop, megaTuskDrop);
    if (variant) {
      // Find which product this variant belongs to
      if (carriageDrop?.variants?.find(v => v.id === variant.id)) product = carriageDrop;
      else if (tuskDrop?.variants?.find(v => v.id === variant.id)) product = tuskDrop;
      else if (megaTuskDrop?.variants?.find(v => v.id === variant.id)) product = megaTuskDrop;
    }
  } else {
    // Handle single selection for other charms
    if (!product?.variants) return null;
    variant = product.variants.find(v => v.id === selectedVariantId);
  }
  
  if (!variant || !product) return null;

  return getVariantImage(variant, product);
}

// Utility function to get combination image
function getCombinationImage(selectedOptions, carriageDrop, getSelectedCharmValue, buildCombinationKey, getCombinationImageUrl, tuskDrop, megaTuskDrop) {
  // Get current selections
  const vesselLetter = getSelectedCharmValue('vesselDrop');
  const carriagePlate = selectedOptions.carriagePlate ? 'carriage' : null;
  
  // Handle stones specially for two-stone combinations - search across all stone products
  let stone = null;
  if (selectedOptions.carriageDrop && Array.isArray(selectedOptions.carriageDrop)) {
    if (selectedOptions.carriageDrop.length === 2) {
      // Get stone names for two-stone combination
      const stones = selectedOptions.carriageDrop.map(id => {
        const variant = findStoneVariant(id, carriageDrop, tuskDrop, megaTuskDrop);
        return variant ? (variant.option2 || variant.option1) : null;
      }).filter(Boolean);
      stone = stones.length === 2 ? stones : null;
    } else if (selectedOptions.carriageDrop.length === 1) {
      // Single stone
      stone = getSelectedCharmValue('carriageDrop');
    }
  } else if (selectedOptions.carriageDrop) {
    // Single stone (backward compatibility)
    stone = getSelectedCharmValue('carriageDrop');
  }
  
  // Create combination key
  const combination = buildCombinationKey(vesselLetter, stone, carriagePlate);
  
  // Debug: log the key
  if (selectionIncludesNonCarriageStone(selectedOptions, carriageDrop, tuskDrop, megaTuskDrop)) {
    console.log('[Necklace Builder] Combination key (tuskDrop/megaTuskDrop):', combination);
  }
  
  // Look up the combination image (even for tuskDrop/megaTuskDrop - images exist in metafields)
  const combinationImage = getCombinationImageUrl(combination);
  
  if (combinationImage) {
    return combinationImage;
  }
  
  // No fallback - if no combination image exists, return null
  // This will trigger overlay mode instead
  return null;
}

// Utility function to check if should use overlay mode
function shouldUseOverlayMode(selectedOptions, carriageDrop, getSelectedCharmValue, buildCombinationKey, getCombinationImageUrl, tuskDrop, megaTuskDrop) {
  const vesselLetter = getSelectedCharmValue('vesselDrop');
  const carriagePlate = selectedOptions.carriagePlate ? 'carriage' : null;
  
  // Handle stones specially for two-stone combinations - search across all stone products
  let stone = null;
  if (selectedOptions.carriageDrop && Array.isArray(selectedOptions.carriageDrop)) {
    if (selectedOptions.carriageDrop.length === 2) {
      // Get stone names for two-stone combination
      const stones = selectedOptions.carriageDrop.map(id => {
        const variant = findStoneVariant(id, carriageDrop, tuskDrop, megaTuskDrop);
        return variant ? (variant.option2 || variant.option1) : null;
      }).filter(Boolean);
      stone = stones.length === 2 ? stones : null;
    } else if (selectedOptions.carriageDrop.length === 1) {
      // Single stone
      stone = getSelectedCharmValue('carriageDrop');
    }
  } else if (selectedOptions.carriageDrop) {
    // Single stone (backward compatibility)
    stone = getSelectedCharmValue('carriageDrop');
  }
  
  const combination = buildCombinationKey(vesselLetter, stone, carriagePlate);
  
  // Debug: log the key
  if (selectionIncludesNonCarriageStone(selectedOptions, carriageDrop, tuskDrop, megaTuskDrop)) {
    console.log('[Necklace Builder] Combination key (tuskDrop/megaTuskDrop):', combination);
  }
  
  // Check if combination image exists (even for tuskDrop/megaTuskDrop - images exist in metafields)
  // Return true (use overlay mode) only if the image doesn't exist
  return !getCombinationImageUrl(combination);
}

// Utility function to get selected charm title
function getSelectedCharmTitle(charmType, selectedOptions, carriagePlate, vesselDrop, carriageDrop, tuskDrop, megaTuskDrop) {
  const selectedVariantId = selectedOptions[charmType];
  if (!selectedVariantId) return '';

  let product, variant;
  switch (charmType) {
    case 'carriagePlate':
      product = carriagePlate;
      break;
    case 'vesselDrop':
      product = vesselDrop;
      break;
    case 'carriageDrop':
      // For carriageDrop, search across all stone products
      if (Array.isArray(selectedVariantId)) {
        // Handle array - use first selected stone
        if (selectedVariantId.length > 0) {
          variant = findStoneVariant(selectedVariantId[0], carriageDrop, tuskDrop, megaTuskDrop);
          if (variant) {
            return variant.option2 || variant.option1 || variant.title || '';
          }
        }
        return '';
      } else {
        // Single stone selection
        variant = findStoneVariant(selectedVariantId, carriageDrop, tuskDrop, megaTuskDrop);
        if (variant) {
          return variant.option2 || variant.option1 || variant.title || '';
        }
        return '';
      }
    default:
      return '';
  }

  if (!product?.variants) return '';
  
  variant = product.variants.find(v => v.id === selectedVariantId);
  if (!variant) return '';

  return variant.option2 || variant.option1 || variant.title || '';
}

// Utility functions for custom scrollbar functionality
function getScrollbarWidth(category) {
  const container = document.querySelector(`[data-category="${category}"]`);
  if (!container) return 20;
  
  const scrollWidth = container.scrollWidth;
  const clientWidth = container.clientWidth;
  
  if (scrollWidth > clientWidth) {
    // Thumb width represents visible portion of content
    const thumbWidthPercent = (clientWidth / scrollWidth) * 100;
    return Math.max(15, thumbWidthPercent);
  } else {
    return 100;
  }
}

function getScrollbarPosition(category, scrollPositions) {
  const container = document.querySelector(`[data-category="${category}"]`);
  if (!container) return 0;
  
  const currentScroll = scrollPositions[category] !== undefined ? 
    scrollPositions[category] : container.scrollLeft;
  
  const maxScroll = container.scrollWidth - container.clientWidth;
  
  if (maxScroll <= 0) return 0;
  
  // Calculate scroll percentage
  const scrollPercentage = (currentScroll / maxScroll) * 100;
  
  // The thumb position needs to account for its own width
  // When at 100% scroll, the right edge of the thumb should touch the right edge of the track
  const thumbWidth = getScrollbarWidth(category);
  const maxPosition = 100 - thumbWidth;
  
  // Position the thumb so it stops at the right edge
  const thumbPosition = (scrollPercentage / 100) * maxPosition;
  
  return Math.max(0, Math.min(maxPosition, thumbPosition));
}

function getScrollbarImagePosition(category, scrollPositions) {
  // Get the container element to calculate actual positions
  const container = document.querySelector(`.custom-scrollbar-container`);
  if (!container) return 0;
  
  const track = container.querySelector('.custom-scrollbar-track');
  if (!track) return 0;
  
  // Get thumb position and width (both in track-relative percentages)
  const thumbPosition = getScrollbarPosition(category, scrollPositions);
  const thumbWidth = getScrollbarWidth(category);
  
  // Get actual dimensions
  const containerRect = container.getBoundingClientRect();
  const trackRect = track.getBoundingClientRect();
  
  // Calculate the center of the thumb in pixels
  const trackWidth = trackRect.width;
  const thumbLeftPx = (thumbPosition / 100) * trackWidth;
  const thumbWidthPx = (thumbWidth / 100) * trackWidth;
  const thumbCenterPx = thumbLeftPx + (thumbWidthPx / 2);
  
  // Convert to container-relative percentage and add responsive offset
  const containerWidth = containerRect.width;
  const basePosition = (thumbCenterPx / containerWidth) * 100;
  
  // Different offset for mobile vs desktop
  const isMobile = window.innerWidth < 768;
  const offset = isMobile ? 4 : 2;
  
  const imagePosition = basePosition + offset;
  
  return Math.max(0, Math.min(100, imagePosition));
}

function scrollToPosition(category, event, scrollPositions) {
  const container = document.querySelector(`[data-category="${category}"]`);
  if (!container) return;
  
  const track = event.currentTarget;
  const rect = track.getBoundingClientRect();
  const clickX = event.clientX - rect.left;
  const trackWidth = rect.width;
  const clickPercentage = clickX / trackWidth;
  
  const maxScroll = container.scrollWidth - container.clientWidth;
  let targetScroll = maxScroll * clickPercentage;
  
  // Ensure we can reach the very end (100% should scroll to maxScroll)
  if (clickPercentage >= 0.95) {
    targetScroll = maxScroll;
  }
  
  // Try direct assignment first
  container.scrollLeft = targetScroll;
  
  // Update the reactive scroll position
  scrollPositions[category] = targetScroll;
  
  // Also try scrollTo as backup
  try {
    container.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  } catch (e) {
    // scrollTo failed, using scrollLeft
  }
}

function startDrag(category, event, scrollPositions) {
  event.preventDefault();
  
  const container = document.querySelector(`[data-category="${category}"]`);
  if (!container) return;
  
  const thumb = event.currentTarget;
  const track = thumb.parentElement;
  const rect = track.getBoundingClientRect();
  
  let isDragging = true;
  
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    
    const mouseX = e.clientX - rect.left;
    const trackWidth = rect.width;
    const clickPercentage = Math.max(0, Math.min(1, mouseX / trackWidth));
    
    const maxScroll = container.scrollWidth - container.clientWidth;
    let targetScroll = maxScroll * clickPercentage;
    
    // Ensure we can reach the very end
    if (clickPercentage >= 0.95) {
      targetScroll = maxScroll;
    }
    
    container.scrollLeft = targetScroll;
    
    // Update the reactive scroll position
    scrollPositions[category] = targetScroll;
  };
  
  const handleMouseUp = () => {
    isDragging = false;
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
    document.removeEventListener('touchmove', handleMouseMove);
    document.removeEventListener('touchend', handleMouseUp);
  };
  
  const handleTouchMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    
    const touch = e.touches[0];
    const mouseX = touch.clientX - rect.left;
    const trackWidth = rect.width;
    const clickPercentage = Math.max(0, Math.min(1, mouseX / trackWidth));
    
    const maxScroll = container.scrollWidth - container.clientWidth;
    let targetScroll = maxScroll * clickPercentage;
    
    // Ensure we can reach the very end
    if (clickPercentage >= 0.95) {
      targetScroll = maxScroll;
    }
    
    container.scrollLeft = targetScroll;
    
    // Update the reactive scroll position
    scrollPositions[category] = targetScroll;
  };
  
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);
  document.addEventListener('touchmove', handleTouchMove, { passive: false });
  document.addEventListener('touchend', handleMouseUp);
}

function initCustomScrollbars(scrollPositions, nextTick) {
  // Add scroll event listeners to update scrollbar positions
  const scrollContainers = document.querySelectorAll('[data-category]');
  scrollContainers.forEach(container => {
    container.addEventListener('scroll', () => {
      // Update the reactive scroll position
      const category = container.dataset.category;
      scrollPositions[category] = container.scrollLeft;
      
      // Force Alpine.js to update the scrollbar position
      nextTick(() => {
        // This will trigger a re-render of the scrollbar
      });
    });
  });
}

// Utility function to detect if user is on a mobile device
function isMobileDevice() {
  // Check for mobile viewport width (typically 768px and below)
  return window.innerWidth <= 768;
}

// Utility function to scroll to top on mobile devices
function scrollToTopOnMobile() {
  if (isMobileDevice()) {
    // Smooth scroll to top of the page
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}


// Copy the complete necklace configuration into the inquiry form at click time.
(function installNecklaceInquiry() {
  if (window.necklaceInquiryInstalled) return;
  window.necklaceInquiryInstalled = true;

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.inquire-popup-trigger');
    const builder = trigger && trigger.closest('[x-data="NecklaceBuilder"]');
    if (!builder || !window.Alpine) return;
    const popup = document.querySelector('.inquire-popup');
    const form = popup && popup.querySelector('form');
    if (!form) return;

    const state = window.Alpine.$data(builder);
    const options = state.selectedOptions || {};
    const base = state.currentVariant || state.mainProduct?.variants?.[0];
    const products = [state.carriagePlate, state.vesselDrop, state.carriageDrop,
      state.tuskDrop, state.megaTuskDrop].filter(Boolean);
    const lines = [state.mainProduct?.title || 'Custom Necklace'];
    if (base) lines.push('Necklace: ' + base.title);
    (state.mainOptions || []).forEach(function (group) {
      const value = options[group.position];
      if (value) lines.push(group.name + ': ' + value);
    });

    Object.entries(options).forEach(function ([key, selection]) {
      if (/^option[123]$/.test(key) || selection == null || selection === '') return;
      const ids = Array.isArray(selection) ? selection : [selection];
      ids.forEach(function (id) {
        const product = products.find(p => p.variants?.some(v => String(v.id) === String(id)));
        const variant = product?.variants.find(v => String(v.id) === String(id));
        lines.push(variant ? product.title + ': ' + variant.title + ' (ID: ' + variant.id + ')'
          : key + ': ' + String(id));
      });
    });
    const total = Number(state.totalPrice);
    const formattedTotal = Number.isFinite(total)
      ? '$' + total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
    if (formattedTotal) lines.push('Total: ' + formattedTotal);
    const summary = lines.join(String.fromCharCode(10));

    function setField(name, value) {
      let input = form.querySelector('[name="contact[' + name + ']"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'contact[' + name + ']';
        form.appendChild(input);
      }
      input.value = value == null ? '' : String(value);
    }
    setField('product', state.mainProduct?.title || 'Custom Necklace Builder');
    setField('variant', base?.title || '');
    setField('variant_id', base?.id || '');
    setField('variant_price', base ? '$' + (Number(base.price)).toFixed(2) : '');
    setField('customizations', summary);
    setField('configuration_total', formattedTotal);
    setField('configuration_options', JSON.stringify(options));

    let preview = form.querySelector('[data-necklace-inquiry-summary]');
    if (!preview) {
      preview = document.createElement('div');
      preview.setAttribute('data-necklace-inquiry-summary', '');
      preview.className = 'mt-4 mb-4 text-sm';
      preview.style.whiteSpace = 'pre-line';
      form.prepend(preview);
    }
    preview.textContent = 'Your necklace configuration' + String.fromCharCode(10) + summary;
  }, true);
})();
